/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type HeatingSourceEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 14;

export const HeatingSourceEnum = {
    NUMBER_1: 1 as HeatingSourceEnum,
    NUMBER_2: 2 as HeatingSourceEnum,
    NUMBER_3: 3 as HeatingSourceEnum,
    NUMBER_4: 4 as HeatingSourceEnum,
    NUMBER_5: 5 as HeatingSourceEnum,
    NUMBER_6: 6 as HeatingSourceEnum,
    NUMBER_7: 7 as HeatingSourceEnum,
    NUMBER_8: 8 as HeatingSourceEnum,
    NUMBER_9: 9 as HeatingSourceEnum,
    NUMBER_10: 10 as HeatingSourceEnum,
    NUMBER_11: 11 as HeatingSourceEnum,
    NUMBER_12: 12 as HeatingSourceEnum,
    NUMBER_14: 14 as HeatingSourceEnum
};

